import Echo from "laravel-echo";
import Pusher from "pusher-js";
import Alpine from "alpinejs";
import "apexcharts";
import { flare } from "@flareapp/flare-client";

if (process.env.NODE_ENV === "production") {
    flare.light(process.env.MIX_FLARE_KEY);
}

function getMetaContent(name) {
    return document.head.querySelector(`meta[name=${name}]`)?.content;
}

const pusherAppKey = getMetaContent("pusher-app-key");

if (pusherAppKey) {
    window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: "pusher",
        key: pusherAppKey,
        wsHost: getMetaContent("pusher-app-host"),
        wssPort: getMetaContent("pusher-app-port"),
        encrypted: true,
        disableStats: true,
        cluster: getMetaContent("pusher-app-cluster"),
    });
}

window.Alpine = Alpine;
Alpine.start();
